import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";
import Chat from "@/components/Chat";

// Acceso al asistente desde pantallas sin conversación (mesa, procesos, mi-empresa):
// un botón chico abajo a la derecha que abre un panel. No está siempre presente.
export default function AsistenteFlotante() {
  const [abierto, setAbierto] = useState(false);

  return (
    <>
      <AnimatePresence>
        {abierto && (
          <>
            <motion.div
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
              className="fixed inset-0 z-40 bg-black/50"
              onClick={() => setAbierto(false)}
              data-testid="asistente-backdrop"
            />
            <motion.aside
              initial={{ x: 400, opacity: 0.6 }} animate={{ x: 0, opacity: 1 }} exit={{ x: 400, opacity: 0.6 }}
              transition={{ type: "spring", stiffness: 320, damping: 34 }}
              className="fixed right-0 top-0 z-50 w-[380px] max-w-[92vw] bg-negro2 border-l border-borde flex flex-col"
              style={{ height: "100vh" }}
              data-testid="asistente-panel"
            >
              <div className="flex items-center justify-between px-5 h-16 border-b border-borde shrink-0">
                <span className="mono-label text-dorado">EL ASISTENTE</span>
                <button onClick={() => setAbierto(false)} className="text-gris hover:text-crema" data-testid="asistente-cerrar" aria-label="Cerrar asistente">
                  <X size={18} />
                </button>
              </div>
              <div className="flex-1 min-h-0 p-5">
                <Chat contexto="general" placeholder="Preguntame lo que quieras…" compact />
              </div>
            </motion.aside>
          </>
        )}
      </AnimatePresence>

      {!abierto && (
        <motion.button
          initial={{ opacity: 0, y: 12 }} animate={{ opacity: 0.55, y: 0 }} whileHover={{ opacity: 1 }}
          onClick={() => setAbierto(true)}
          className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full pl-3.5 pr-4 py-2.5 btn-dorado shadow-lg transition-opacity"
          data-testid="asistente-flotante-btn"
        >
          <MessageCircle size={15} />
          <span className="mono-label" style={{ fontSize: "10px" }}>PREGUNTAR</span>
        </motion.button>
      )}
    </>
  );
}
